(() => {
  const onlyDigits = (value) => String(value || '').replace(/\D/g, '');

  const buildPhone = (dialEl, phoneEl) => {
    const dialValue = String(dialEl?.value || '+39').trim() || '+39';
    const dialDigits = onlyDigits(dialValue);
    const raw = String(phoneEl?.value || '').trim();
    let national = onlyDigits(raw);

    // Togli il prefisso solo se è stato incollato (+39… / 0039…).
    // Non toccare un nazionale che inizia con le stesse cifre (es. 393…).
    const pastedInternational = raw.startsWith('+') || raw.startsWith('00');
    if (national.startsWith('00')) national = national.slice(2);
    if (pastedInternational && dialDigits && national.startsWith(dialDigits)) {
      national = national.slice(dialDigits.length);
    }
    // IT: togli lo 0 iniziale del nazionale
    if (dialDigits === '39' && national.startsWith('0')) {
      national = national.slice(1);
    }

    if (!national) return { e164: '', display: '', digits: '' };

    const e164 = `+${dialDigits}${national}`;
    const display = `${dialValue} ${national}`;
    const digits = `${dialDigits}${national}`;
    return { e164, display, digits };
  };

  const setLoading = (form, cta) => {
    form.setAttribute('aria-busy', 'true');
    if (!cta) return;
    cta.classList.add('is-loading');
    if (!cta.dataset.rlLabel) cta.dataset.rlLabel = cta.textContent || '';
    const root = form.closest('[data-rl-wa-notify]');
    cta.textContent = root?.getAttribute('data-submitting-msg') || cta.dataset.rlLabel;
    // Disabilita al tick dopo: disabilitarlo nel submit ferma l'invio su alcuni browser.
    window.setTimeout(() => {
      cta.disabled = true;
    }, 0);
  };

  const bind = (form) => {
    if (form.dataset.rlWaBound === '1') return;
    form.dataset.rlWaBound = '1';

    const dial = form.querySelector('[data-rl-dial]');
    const phone = form.querySelector('[data-rl-phone]');
    const phoneFull = form.querySelector('[data-rl-phone-full]');
    const consent = form.querySelector('[data-rl-consent]');
    const email = form.querySelector('[data-rl-email]');
    const body = form.querySelector('[data-rl-body]');
    const cta = form.querySelector('[data-rl-cta]');
    const root = form.closest('[data-rl-wa-notify]');
    const handle = root?.getAttribute('data-product-handle') || '';

    const sync = () => {
      if (form.dataset.rlSubmitting === '1') return;
      const ready = Boolean(consent?.checked) && Boolean(onlyDigits(phone?.value));
      if (cta) cta.disabled = !ready;
      cta?.classList.toggle('is-ready', ready);
    };

    phone?.addEventListener('input', sync);
    consent?.addEventListener('change', sync);
    dial?.addEventListener('change', sync);
    sync();

    form.addEventListener('submit', (event) => {
      if (form.dataset.rlSubmitting === '1') {
        event.preventDefault();
        return;
      }

      const { e164, display, digits } = buildPhone(dial, phone);
      if (!digits || !consent?.checked) {
        event.preventDefault();
        return;
      }

      // Invio nativo di Shopify: il fetch non vede la conferma e faceva
      // comparire l'errore prima del reload con il messaggio giusto.
      form.dataset.rlSubmitting = '1';
      if (phoneFull) phoneFull.value = e164;
      if (email) email.value = `${digits}@notify.redlinejapan.com`;
      if (body) {
        const title =
          document.querySelector('h1.product__title, .product__title, h1')?.textContent?.trim() ||
          handle;
        const url = window.location.href.split('?')[0];
        body.value = [
          'WhatsApp restock notify',
          `Product: ${title}`,
          `Handle: ${handle}`,
          `URL: ${url}`,
          `Phone: ${display}`,
        ].join('\n');
      }

      setLoading(form, cta);
    });
  };

  const init = () => {
    document.querySelectorAll('[data-rl-wa-notify] form').forEach(bind);
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
